import type { StatsPage } from '../../../../services/competition/getStatsPage'

/**
 * The page to request after `lastPage`, or `undefined` when the list is done.
 *
 * Mirrors the Statistics tabs' original infinite-scroll rule: with a `count`,
 * there is more while `current_page * per_page < count`; without one, keep
 * going until a page comes back empty. `current_page` can arrive as a string,
 * and falls back to the page that was requested.
 */
export const getNextStatsPage = (
  lastPage: StatsPage,
  requestedPage: number
): number | undefined => {
  const pagination = lastPage.meta?.pagination
  const currentPage = Number(pagination?.current_page ?? requestedPage)
  const perPage = pagination?.per_page ?? lastPage.data.length
  const total = pagination?.count ?? 0

  const hasMore = total
    ? currentPage * perPage < total
    : lastPage.data.length > 0

  return hasMore ? currentPage + 1 : undefined
}

/** Every loaded page's rows, in page order. */
export const flattenStatsPages = <Row>(
  pages: StatsPage<Row>[] | undefined
): Row[] => ([] as Row[]).concat(...(pages ?? []).map((page) => page.data))
